import React, { useCallback } from 'react';
import classnames from 'classnames';
import { forTemplate } from '@trello/i18n';
import { Analytics } from '@trello/atlassian-analytics';
import styles from './TrelloEnterpriseLearnMore.less';
import { useTrelloEnterpriseLearnMoreMemberIdQuery } from './TrelloEnterpriseLearnMoreMemberIdQuery.generated';

const format = forTemplate('mini_plan_comparison');

interface TrelloEnterpriseLearnMoreProps {
  hideOnSmallScreens?: boolean;
}

export const TrelloEnterpriseLearnMore: React.FC<TrelloEnterpriseLearnMoreProps> = ({
  hideOnSmallScreens = false,
}) => {
  const { data } = useTrelloEnterpriseLearnMoreMemberIdQuery();
  const trackLearnMoreClick = useCallback(() => {
    Analytics.sendClickedLinkEvent({
      linkName: 'learnMoreLink',
      source: 'planSelectionModal',
      attributes: {
        memberId: data?.member?.id,
        organizationIds: data?.member?.idOrganizations,
      },
    });
  }, [data?.member?.idOrganizations, data?.member?.id]);

  return (
    <div
      className={classnames({
        [styles.checkoutEnterprise]: true,
        [styles.hideOnSmallScreens]: hideOnSmallScreens,
      })}
    >
      <p className={styles.content}>
        {format('check-out-trello-enterprise')}{' '}
        <a
          href="https://trello.com/enterprise"
          target="_blank"
          className={styles.enterpriseLink}
          onClick={trackLearnMoreClick}
        >
          {format('enterprise-learn-more')}
        </a>
      </p>
    </div>
  );
};
